import {
    ComponentKind,
    TableColumn,
    isPrimitiveType,
    getTableColumnDisplayName,
    makeEmptyComponentDescription,
} from "../description";
import { assert } from "../../Support";
import { ToggleComponentHandler, ToggleComponentDescription } from "./toggle";
import { makeColumnProperty, makeStringProperty } from "./property-utils";

const ComponentKindSwitch: ComponentKind = "switch";

export class SwitchComponentHandler extends ToggleComponentHandler {
    constructor() {
        super(ComponentKindSwitch, ["flag", "switch"]);
    }

    protected readonly name = "Switch";
    protected readonly description = "An on/off switch";
    protected readonly img = "componentSwitch";
    protected readonly docPath = "toggle";

    protected readonly uiName = "ToggleSwitch";

    public static defaultComponent(column: TableColumn): ToggleComponentDescription {
        assert(isPrimitiveType(column.type));
        return {
            ...makeEmptyComponentDescription(ComponentKindSwitch),
            propertyName: makeColumnProperty(column.name),
            defaultValue: undefined,
            primaryKeyProperty: undefined,
            caption: makeStringProperty(getTableColumnDisplayName(column)),
            description: undefined,
            mustBeActive: undefined,
            allowWrapping: undefined,
        };
    }
}
